import { useEffect } from 'react';

export function useStructuredData(schema: object | object[]): void {
  useEffect(() => {
    const schemas = Array.isArray(schema) ? schema : [schema];
    const scriptTags: HTMLScriptElement[] = [];

    schemas.forEach((s, i) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = `structured-data-${i}`;
      script.textContent = JSON.stringify(s);
      document.head.appendChild(script);
      scriptTags.push(script);
    });

    return () => {
      scriptTags.forEach((tag) => {
        if (tag.parentNode) {
          tag.parentNode.removeChild(tag);
        }
      });
    };
  }, []);
}
